export enum LogLevel {
  /**
   * @generated from protobuf enum value: Unspecified = 0;
   */
  Unspecified = 0,
  /**
   * @generated from protobuf enum value: Debug = 1;
   */
  Debug = 1,
  /**
   * @generated from protobuf enum value: Info = 2;
   */
  Info = 2,
  /**
   * @generated from protobuf enum value: Warning = 3;
   */
  Warning = 3,
  /**
   * @generated from protobuf enum value: Error = 4;
   */
  Error = 4,
  /**
   * @generated from protobuf enum value: Fatal = 5;
   */
  Fatal = 5
}
